export default "__VITE_ASSET__df4ef67b__"